import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["path", "handleValueChange", "details"];
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useConfigurationData } from "../utils/ConfigurationComponentUtils";
import { HtmlString } from "../../Utils";
import ConfigurationSetToNull from "./ConfigurationSetToNull";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%",
      flexGrow: 1,
      "& .MuiTypography-root": {
        marginBottom: theme.spacing(1)
      }
    },
    textField: {
      backgroundColor: "#FBFBFB",
      minWidth: "50%",
      borderRadius: theme.shape.borderRadius
    },
    input: {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius
    }
  };
});
var ConfigurationTextField = function ConfigurationTextField(_ref) {
  var path = _ref.path,
    handleValueChange = _ref.handleValueChange,
    details = _ref.details,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var _useConfigurationData = useConfigurationData(path),
    _useConfigurationData2 = _slicedToArray(_useConfigurationData, 2),
    data = _useConfigurationData2[0],
    setData = _useConfigurationData2[1];
  var onChange = function onChange(event) {
    var newData = _objectSpread({}, data);
    newData.value = event.target.value + "";
    newData.blankValue = newData.value === "";
    setData(newData);
    if (handleValueChange) {
      handleValueChange(newData);
    }
  };
  var helperText = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ConfigurationSetToNull, {
    data: data,
    setData: setData
  }), /*#__PURE__*/React.createElement(HtmlString, {
    text: data.description
  }), details);
  var textField = data && /*#__PURE__*/React.createElement(TextField, Object.assign({
    className: classes.textField,
    size: "medium",
    required: data.required,
    error: data.required && !data.value,
    label: data.label,
    type: data.type,
    variant: "outlined",
    value: data.value,
    onChange: onChange,
    id: data.id,
    InputProps: {
      className: classes.input
    },
    helperText: helperText
  }, props));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, textField);
};
export default ConfigurationTextField;